import ALoaderAc from './a-loader-h2h.vue';

export default ALoaderAc;
